import apiClient from '@/utils/request'

import {
  IFlatDealResponse,
  IFlatDealsResponse,
  IFlatDealsPayload,
  IFlatDealCreateForm,
  IFlatDealBuyForm
} from '@/apps/traforama/interfaces/flatDeals'
import { nestedQueryFormatter } from '@/utils/query'
import { serialize } from 'object-to-formdata'

export const fetchItems = async (
  payload: IFlatDealsPayload
): Promise<IFlatDealsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter)
  )
  const response = await apiClient.get<IFlatDealsResponse>('/flat_deals', {
    params
  })
  return response.data
}

export const fetchItem = async (id: string): Promise<IFlatDealResponse> => {
  const response = await apiClient.get<IFlatDealResponse>(`/flat_deals/${id}`)
  return response.data
}

export const fetchEditItem = async (id: string): Promise<IFlatDealResponse> => {
  const response = await apiClient.get<IFlatDealResponse>(
    `/flat_deals/${id}/edit`
  )
  return response.data
}

export const buyItem = async (
  item: IFlatDealBuyForm
): Promise<IFlatDealResponse> => {
  const form = serialize(item)
  const response = await apiClient.post<IFlatDealResponse>(
    '/flat_deals/buy',
    form
  )
  return response.data
}

export const createItem = async (
  item: IFlatDealCreateForm
): Promise<IFlatDealResponse> => {
  const form = serialize(item)
  const response = await apiClient.post<IFlatDealResponse>('/flat_deals', form)
  return response.data
}

export const changeDealState = async (
  id: number,
  event: string,
  reason?: string
): Promise<IFlatDealResponse> => {
  const options = {
    status_change_reason: reason
  }
  const response = await apiClient.post<IFlatDealResponse>(
    `/flat_deals/${id}/${event}`,
    options
  )
  return response.data
}

export const fetchStats = async (id: number): Promise<any[]> => {
  const response = await apiClient.get<any[]>(`/flat_deals/${id}/fetch_stats`)
  return response.data
}

export const fetchBuffetReport = async (): Promise<any[]> => {
  const response = await apiClient.get<any[]>(`/flat_deals/fetch_buffet_report`)
  return response.data
}

export interface IEstimatePriceParams {
  spot_id: number
  type_id: number
  size_id?: number
  country_codes: string[]
  device_ids: number[]
  deal_type: number
}

export interface IEstimatePriceResult {
  cpm_rate: number | null
  daily_fee: number | null
  avg_daily_impressions: number
  estimated_ecpm: number | null
  deal_type: number
}

export const estimatePrice = async (
  params: IEstimatePriceParams
): Promise<IEstimatePriceResult> => {
  const response = await apiClient.post<IEstimatePriceResult>(
    '/flat_deals/estimate_price',
    params
  )
  return response.data
}
